import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

let supabase;

// Fail-safe: if env vars are missing, create a safe mock client to avoid crashing the app
if (!supabaseUrl || !supabaseAnonKey) {
  // Minimal no-op mock that preserves expected shapes to prevent runtime errors
  // and lets the app run without Supabase connectivity.
  const noop = () => {};
  supabase = {
    auth: {
      async getSession() {
        return { data: { session: null } };
      },
      onAuthStateChange(callback) {
        // Return object with the same shape used in the app
        return { data: { subscription: { unsubscribe: noop } } };
      },
      async signUp() {
        return { data: null, error: { message: 'Supabase no configurado' } };
      },
      async signInWithPassword() {
        return { data: null, error: { message: 'Supabase no configurado' } };
      },
      async signOut() {
        return { error: null };
      }
    },
    from() {
      return {
        async select() { return { data: null, error: { message: 'Supabase no configurado' } }; },
        async update() { return { data: null, error: { message: 'Supabase no configurado' } }; },
      };
    }
  };
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    realtime: {
      params: {
        eventsPerSecond: 2
      }
    }
  });
}

export { supabase };